import { useParams } from "react-router-dom";
import useInquiry from "apis/queries/useInquiry";
import HistoryItem from "components/layouts/Header/ModalPalette/History/Item";

// 샘플신청 내역
const History = () => {
  const params = useParams();
  const projectId = Number(params.id);

  // 신청 내역 api
  const inquiries = useInquiry(projectId);

  if (!inquiries) return null;

  return (
    <div className="flex-1 overflow-y-scroll mr-[-16px] pr-2">
      {inquiries.map((inquire) => {
        return <HistoryItem inquire={inquire} key={inquire.id} />;
      })}
    </div>
  );
};

export default History;
